import styled, { css } from 'styled-components';

export const NewSupplierBadge = styled.div`
  position: absolute;
  top: -10px;
  left: 12px;
  background: ${({ theme }) => theme.pantone2726C};
  color: white;
  padding: 2px 10px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  z-index: 1;
`;

const directAssignColumnBase = css`
  padding: 12px 8px;
  display: flex;
  align-items: center;
  min-width: 0;
  box-sizing: border-box;
  min-height: 80px;

  & > * {
    width: 100%;
  }
`;

export const DirectAssignRowContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  min-height: 80px;
  min-width: 1100px;
`;

export const DirectAssignSupplierCol = styled.div`
  ${directAssignColumnBase};
  flex: 2;
`;

export const DirectAssignPartTypeCol = styled.div`
  ${directAssignColumnBase};
  flex: 2;
`;

export const DirectAssignDeadlineCol = styled.div`
  ${directAssignColumnBase};
  flex: 1.3;
`;

export const DirectAssignPriceCol = styled.div`
  ${directAssignColumnBase};
  flex: 1;
`;
